import { Box } from "@mui/material";
import styled from "styled-components";

export const Container = styled(Box)`
  width: 60px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Content = styled(Box)`
  height: 92px;
  width: 60px;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: -20px;
  background-color: #f4f4f4;
  z-index: 22;
  border-radius: 10px;
`;

export const IconWrapper = styled(Box)`
  display: flex;
  height: 40px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  z-index: 22;
  &:hover {
    background-color: white;
  }
`;

export const CalendarIconWrapper = styled(Box)`
  display: flex;
  height: 40px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  z-index: 22;
`;
